import { Card, FeatureToggles, ThemePicker } from '@qrkey/ui';
import { Link } from '@tanstack/react-router';
import { useSession } from '../app/api.js';

export function AppearancePanel() {
  const session = useSession();
  return (
    <Card
      title="Appearance"
      titleLevel={1}
      description={
        session
          ? 'Your choice is kept on this device for you. Changes apply straight away.'
          : 'Kept on this device until someone signs in; each person can pick their own.'
      }
    >
      <ThemePicker />
      <FeatureToggles />
    </Card>
  );
}

/** Before sign-in: the same panel on its own page. */
export function PublicAppearanceScreen() {
  return (
    <main id="main" className="auth__main auth__main--wide appearance-page">
      <AppearancePanel />
      <Link to="/">Back</Link>
    </main>
  );
}
